import React, { useState, useRef, useLayoutEffect, useCallback } from "react"

import useDebounce from "../../helpers/useDebounce"
import BlogTag from "../blog-tag/blog-tag.component"
import {
  BlogTagContainer,
  CheveronIcon,
  TagsContainer,
} from "./post-preview-tags.styles"

const PostPreviewTags = ({ blogPost, tags, onTagChange }) => {
  const [isCheveronOpen, setisCheveronOpen] = useState(false)
  const [isOverflowing, setIsOverflowing] = useState(false)

  const tagContainer = useRef()

  // eslint-disable-next-line
  const isOverflown = useCallback(
    useDebounce(() => {
      if (
        tagContainer.current.scrollHeight > tagContainer.current.clientHeight
      ) {
        setIsOverflowing(true)
      } else {
        setIsOverflowing(false)
      }
    }, 100),
    []
  )

  useLayoutEffect(() => {
    isOverflown()
    window.addEventListener("resize", isOverflown)
    return () => window.removeEventListener("resize", isOverflown)
  }, [isOverflown])

  return (
    <BlogTagContainer hasTag={tags !== null}>
      <TagsContainer ref={tagContainer} isOpen={isCheveronOpen}>
        {tags &&
          tags.map((tag, id) => (
            <BlogTag
              key={id}
              value={tag.value}
              label={tag.label}
              slug={tag.tagSlug}
              blogPost={blogPost}
            />
          ))}
      </TagsContainer>

      {isOverflowing ? (
        <div>
          <CheveronIcon
            onClick={() => setisCheveronOpen(!isCheveronOpen)}
            isCheveronOpen={isCheveronOpen}
          >
            <svg
              width="11"
              height="5"
              viewBox="0 0 13 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L6.5 6L12 1"
                stroke="#4C0FFB"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CheveronIcon>
        </div>
      ) : null}
    </BlogTagContainer>
  )
}

export default PostPreviewTags
